import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRelatedCargoRaily from "./billings-order-related-cargo-raily";
import BillingsOrderRelatedCargoRailyParams from "./billings-order-related-cargo-raily-params";

const useBillingsOrderRelatedCargoRaily = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRelatedCargoRaily[]>([]);

  const load = async (
    params: BillingsOrderRelatedCargoRailyParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderRelatedCargoRailyBillings(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRelatedCargoRaily;
